import PosthogService from '~/services/posthog/PosthogService';

// Event-specific interface (co-located)
export interface IInterviewRequestNextClickedPayload {
  postingId: string;
  interviewCount: number;
}

/**
 * Fires when user clicks "Next" on the interview request page
 * Event: dental_portal:interview_request:next_clicked
 */
export function fireInterviewRequestNextClicked(payload: IInterviewRequestNextClickedPayload): void {
  PosthogService.getInstance().track('dental_portal:interview_request:next_clicked', {
    posting_id: payload.postingId,
    interview_count: payload.interviewCount,
  });
}